import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
// const { $ } = window

export default {
	init() {
		// gsap.registerPlugin(ScrollTrigger)

		singlePostSidebar()
		// animatePost()

		let $clipboardLink = $('.clipboard-copy')
		if($clipboardLink.length){
			$clipboardLink.click((e) => {
				e.preventDefault()
				navigator.clipboard.writeText($clipboardLink[0].href.replace('#', ''));
			})
		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function animatePost() {
	breadcrumb()
	hero()
	// content()
	social()
	//sidebar()
	relatedPosts()
}

function breadcrumb() {
	let $breadcrumb = $('.breadcrumb')
	if (!$breadcrumb.length) { return }
	gsap.from($breadcrumb, { opacity: 0, ease: 'power1.out' })
}

function hero() {
	let $hero = $('.single-post--banner')
	if (!$hero.length) { return }
	gsap.from($hero, { opacity: 0, y: 32, duration: 0.35, ease: 'power1.out' })
}
function content() {
	let $content = $('.single-post--content')
	if (!$content.length) { return }
	gsap.from($content, { opacity: 0, y: 32, delay: 0.35, duration: 0.35, ease: 'power1.out' })
}

function social() {
	let $social = $('.social-share--list')
	if (!$social.length) { return }
	gsap.from($social.find('a'), { opacity: 0, y: 32, delay: 0.6, duration: 0.35, ease: 'power1.out', stagger: 0.05 })
}
// function sidebar() {
// 	let $sidebar = $('.single-post--content-sidebar')
// 	if (!$sidebar.length) { return }
// 	gsap.from($sidebar, { opacity: 0, y: 32, delay: 0.35, duration: 0.35, ease: 'power1.out', scrollTrigger: { trigger: $('.single-post--content-sidebar'), start: 'top: 90%' } })
// }
function relatedPosts() {
	let $related = $('.related-posts .post-cards--grid-wrap')
	if (!$related.length) { return }
	gsap.from(
		$related, {
		duration: 0.35,
		opacity: 0,
		scrollTrigger: {
			trigger: '.related-posts',
			start: 'top 90%'
		},
		y: 32,
		ease: 'power1.out',
		stagger: 0.1
	})
}

function singlePostSidebar() {
	$('.single-post--content-sidebar').theiaStickySidebar({
		// Settings
		additionalMarginTop: -110
	});

}
